<template>
    <div id="package_core_waybill">
        <div class="ui divider">
        </div>

        <!-- 切換 包與被包 目標 -->
        <div class="current_pack" v-if="settings.is_package_mode || is_initialized">

            <!-- 包材 -->
            <div class="ui top pointing dropdown button"
                style="margin-right: 0;"
                @change="$forceUpdate()"
                v-dropdown>
                <div class="text"
                    v-for="material in materials"
                    v-if="current_pack_taget_parent_material.identity == material.identity">
                    {{ current_pack_taget_parent_material.name }}
                </div>
                <div class="text"
                    v-if="!current_pack_taget_parent_material.name"
                    >
                    <!-- 包材 -->
                    {{ $t('ui.general.please_select') }}
                    {{ $t('ui.scanner.package.packing_material') }}

                </div>
                <div class="menu">
                    <div class="item"
                        v-for="material in materials"
                        @click="current_store.current_pack_taget_parent_material_identity = material.identity"
                        :class="{
                            'active': material.identity == current_pack_taget_parent_material.identity
                        }">
                        {{ material.name }}
                    </div>
                </div>
            </div>

            <span style="
                font-size: 20px;
                vertical-align: sub;"
            >
                <!-- 包 -->
                {{ $t('ui.scanner.package.package') }}
            </span>
            <!-- 包裝目標 -->
            <div class="ui top pointing dropdown button"
                @change="$forceUpdate()"
                v-dropdown>
                <div class="text"
                    v-for="material in materials"
                    v-if="current_pack_taget_material.identity == material.identity">
                    {{ current_pack_taget_material.name }}
                </div>
                <div class="text"
                    v-if="!current_pack_taget_material.name"
                    >
                    <!-- 請選擇包裝目標 -->
                    {{ $t('ui.scanner.helps.select_pack_taget') }}
                </div>

                <div class="menu">
                    <div class="item"
                        v-for="material in materials"
                        @click="current_store.current_pack_taget_material_identity = material.identity"
                        :class="{
                            'active': material.identity == current_pack_taget_material.identity
                        }">
                        {{ material.name }}
                    </div>
                </div>
            </div>

            <div class="ui checkbox"
                style="vertical-align: middle;">
                <input type="checkbox"
                    v-model="settings.is_pack_need_source_mode">
                <label
                    class="pointer"
                    :class="{active:settings.is_pack_need_source_mode}"
                    @click="current_store.settings.is_pack_need_source_mode = !current_store.settings.is_pack_need_source_mode">
                    <!-- 套用資料 -->
                    {{ $tc('ui.scanner.settings.is_pack_need_source_mode.short_name') }}
                </label>
            </div>

        </div>

        <!-- 提示 message -->
        <div
            class="package_message"
            :class="[package_message.status]"
            v-if="package_message.content"
        >
            {{ package_message.content }}
        </div>

        <!-- 當前包裝結果 -->
        <h2 style="margin: 0;">
            {{ current_package.parent_core_waybill.number || package_no_number_content }}
            <span class="material_name"
                v-if="current_package.parent_core_waybill.material">
                [{{ current_package.parent_core_waybill.material.name }}]
            </span>
        </h2>

        <div class="goods" v-if="current_package.core_waybills.length">
            <h3 v-for="core_waybill in current_package.core_waybills">
                {{ core_waybill.number }}
                <span class="material_name"
                    v-if="core_waybill.material">
                    [{{ core_waybill.material.name }}]
                </span>
            </h3>
            <div class="fluid ui button no border" @click="submit_package()">
                {{ $t('ui.general.submit') }}
            </div>
        </div>

        <!-- 包裝送出 歷史紀錄 -->
        <div class="ui list package_response_history"
            v-if="desc_ordered_package_response_history.length">

            <PackageHistoryItem
                class="item"
                v-for="package_response in desc_ordered_package_response_history"
                :key="package_response.id"
                :package_response="package_response"
            >
            </PackageHistoryItem>

        </div>

    </div>
</template>

<script>
import PackageHistoryItem from './package_history_item.vue'

export default {
    components: {
        PackageHistoryItem
    },
    props: {
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_initialized: false,
            // package_no_number_content: "請選定目標層",
            package_no_number_content: this.$t('ui.scanner.helps.select_target_layer'),
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        'settings.is_pack_need_source_mode'(value) {
            this.fetch_and_set_local_storage('is_pack_need_source_mode', value)
        },
        // 包材
        'settings.pack_target_parent_mode'(value) {
            this.fetch_and_set_local_storage('pack_target_parent_mode', value)
            this.init()
        },
        // 目標物
        'settings.pack_target_mode'(value) {
            this.fetch_and_set_local_storage('pack_target_mode', value)
            this.init()
        },
        // 包材
        'current_pack_taget_parent_material'(value) {
            if (value.class_name != this.settings.pack_target_parent_mode) {
                this.clear_current_pack()
            }
            this.settings.pack_target_parent_mode = value.class_name
        },
        // 目標物
        'current_pack_taget_material'(value) {
            this.settings.pack_target_mode = value.class_name
        },
    },
    computed: {
        current_store() {
            return this.$store.state.customer.scanner_module
        },
        settings() {
            return this.current_store.settings
        },
        current_pack_taget_parent_material() {
            return this.$store.getters['customer/scanner_module/current_pack_taget_parent_material']
        },
        current_pack_taget_material() {
            return this.$store.getters['customer/scanner_module/current_pack_taget_material']
        },
        materials() {
            return this.current_store.materials
        },
        current_package: {
            cache: false,
            get() {
                return this.current_store.package
            }
        },
        package_message() {
            return this.current_store.package_message
        },
        desc_ordered_package_response_history() {
            return _.orderBy(this.current_store.package_response_history, 'id', 'desc')
        },
    },
    methods: {
        async init() {
            this.is_initialized = false
            await this.set_pack_material()
            await this.set_package_no_number_content()
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
        set_pack_material() {
            // 包材
            if (this.settings.pack_target_parent_mode) {
                var result = _.find(this.materials, (material) => {
                    var re = new RegExp(this.settings.pack_target_parent_mode, 'i')
                    return material.class_name.match(re)
                })

                this.current_store.current_pack_taget_parent_material_identity  = result.identity
                    ? result.identity
                    : ""
            }

            // 目標
            if (this.settings.pack_target_mode) {
                var result = _.find(this.materials, (material) => {
                    var re = new RegExp(this.settings.pack_target_mode, 'i')
                    return material.class_name.match(re)
                })

                this.current_store.current_pack_taget_material_identity = result.identity
                    ? result.identity
                    : ""
            }
            return Promise.resolve()
        },
        set_package_no_number_content() {
            try {
                if (!this.current_pack_taget_parent_material.name) {
                    // throw "請選定包材"
                    throw this.$t('ui.scanner.helps.select_pack_taget_parent')
                }
                if (!this.current_pack_taget_material.name) {
                    // throw "請選包裝目標"
                    throw this.$t('ui.scanner.helps.select_pack_taget')
                }
                throw this.$t('ui.scanner.helps.scan') + " " + this.current_pack_taget_parent_material.name

            } catch (err) {
                this.package_no_number_content = err
            }
        },
        fetch_and_set_local_storage(string = "", default_value = "") {
            var name = `scanner_${string}`
            var reslut = localStorage.getItem(name)
            if (default_value === false) {
                localStorage.setItem(name, default_value)
            }

            if (reslut == null || reslut == '' || default_value != "") {
                localStorage.setItem(name, default_value)
                return default_value
            }
            return localStorage.getItem(name)
        },
        async submit_package() {
            await this.$store.dispatch('customer/scanner_module/submit_package')
            await this.clear_current_pack()
        },
        clear_current_pack() {
            this.current_store.package = {
                parent_core_waybill: {},
                core_waybill_identities: [],
                core_waybills: [],
                source_core_waybill_identity: null
            }

            return Promise.resolve()
        },
    },

}
</script>

<style lang="scss" scoped>
    .center.aligned {
        text-align: center;
    }
    .left.aligned {
        text-align: left;
    }
    .right.aligned {
        text-align: right;
    }

    #package_core_waybill {
        & {
            position: relative;
            padding: 0 18px;
            min-height: 250px;
        }
        .goods {
            border: 3px white solid;
        }
        .goods h3:first-child {
            padding-top: 6px
        }
        .goods h3 {
            padding: 3px 12px;
            margin: 0;
        }
        .material_name {
            font-size: small;
            padding-left: 6px;
        }
        .ui.selection.dropdown .menu {
            min-height: 12rem;
        }
    }
    .package_response_history {
        max-height: 90px;
        overflow: auto;
        padding-top: 12px;
        border-top: 1px solid lightgray;
    }

    .current_pack {
        & {
            width: 100%;
            text-align: center;
            padding-bottom: 12px;
        }
        .ui.slider.checkbox input:checked~.box:before,
        .ui.slider.checkbox input:checked~label:before {
            background-color: #2185d0 !important;
        }
        .ui.slider.checkbox .box:before,
        .ui.slider.checkbox label:before {
            background-color: red !important;
        }
        label {
            color: #666 !important;
        }
        label.active {
            color: white !important;
        }
    }

    .package_message {
        & {
            padding-top: 6px;
            text-align: center;
        }
        &.failure {
            color: red;
        }
    }


    @media only screen and (max-width: 767px) {
        #package_core_waybill {
            .ui.selection.dropdown .menu {
                min-height: 14rem;
            }
        }
    }

</style>
